import { useState } from 'react';
import { DynamicSEO } from '../components/seo';
import Layout from '../components/Layout';
import { Calendar, User, Tag } from 'lucide-react';

const POSTS_PER_PAGE = 6;

export default function BlogPage() {
  const [visiblePosts, setVisiblePosts] = useState(POSTS_PER_PAGE);

  const blogPosts = [
    {
      id: 1,
      title: "Popular Nepali Baby Names in 2024",
      excerpt: "Discover the trending Nepali baby names and their meanings that parents are choosing in 2024.",
      date: "2024-03-15",
      author: "Aarav Sharma",
      category: "Baby Names",
      image: "https://images.unsplash.com/photo-1555252333-9f8e92e65df9?auto=format&fit=crop&q=80"
    },
    {
      id: 2,
      title: "Understanding Nepali Name Traditions",
      excerpt: "Learn about the cultural significance and traditions behind Nepali naming ceremonies.",
      date: "2024-03-10",
      author: "Priya Adhikari",
      category: "Culture",
      image: "https://images.unsplash.com/photo-1564507592333-c60657eea523?auto=format&fit=crop&q=80"
    },
    // Add more blog posts...
  ];

  const loadMore = () => {
    setVisiblePosts(prev => prev + POSTS_PER_PAGE);
  };

  return (
    <Layout>
      <DynamicSEO
        meta={{
          title: "Blog - NameExplorer | Insights on Nepali Names and Culture",
          description: "Read our latest articles about Nepali baby names, naming traditions, and cultural insights.",
          keywords: "nepali names blog, baby naming blog, nepali culture, naming traditions",
          type: "blog"
        }}
      />
      
      <div className="max-w-7xl mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-gray-900 text-center mb-12">
          Our Blog
        </h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.slice(0, visiblePosts).map(post => (
            <article 
              key={post.id}
              className="bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow"
            >
              <img
                src={post.image}
                alt={post.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <div className="flex items-center gap-4 text-sm text-gray-600 mb-3">
                  <span className="flex items-center gap-1">
                    <Calendar size={16} />
                    {new Date(post.date).toLocaleDateString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <User size={16} />
                    {post.author}
                  </span>
                </div>
                
                <h2 className="text-xl font-semibold text-gray-900 mb-2">
                  {post.title}
                </h2>
                
                <p className="text-gray-600 mb-4">
                  {post.excerpt}
                </p>
                
                <div className="flex items-center justify-between">
                  <span className="flex items-center gap-1 text-sm text-purple-600">
                    <Tag size={16} />
                    {post.category}
                  </span>
                  <a
                    href={`/blog/${post.id}`}
                    className="text-purple-600 hover:text-purple-700 font-medium"
                  >
                    Read More →
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>

        {visiblePosts < blogPosts.length && (
          <div className="text-center mt-12">
            <button
              onClick={loadMore}
              className="px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
            >
              Load More Posts
            </button>
          </div>
        )}
      </div>
    </Layout>
  );
}